import theme from 'styles/themes/default';

type Props = {
  'data-test'?: string;
  className?: string;
};

const ICON_STROKE_COLOR = '#4A4A4A';

function Devices(props: Props) {
  return (
    <svg {...props} fill="none" height="339" viewBox="0 0 617 339" width="617">
      <rect
        fill={theme.colors.black.primary}
        fillOpacity="0"
        height="335.5"
        transform="translate(1 2)"
        width="614.5"
      />
      <rect
        fill={theme.colors.black.primary}
        fillOpacity="0"
        height="335.5"
        transform="translate(1 2)"
        width="614.5"
      />
      <rect
        fill={theme.colors.black.primary}
        fillOpacity="0"
        height="335"
        transform="translate(59 2)"
        width="541"
      />
      <path
        d="M597 2H62C60.3431 2 59 3.34315 59 5V292C59 293.657 60.3431 295 62 295H597C598.657 295 600 293.657 600 292V5C600 3.34315 598.657 2 597 2Z"
        fill={theme.colors.gray['200']}
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <path
        d="M347.499 128.5C340.134 128.555 333.278 132.298 329.2 138.489C325.121 132.299 318.265 128.556 310.901 128.5C305.093 128.498 299.523 130.826 295.415 134.971C291.308 139.116 289 144.739 289 150.602C289 158.351 293.858 163.94 298.938 169.103L318.792 188.051C319.268 188.505 319.967 188.627 320.567 188.362C321.167 188.096 321.552 187.495 321.545 186.834V172.092C321.545 167.824 324.972 164.365 329.2 164.365C333.428 164.365 336.855 167.824 336.855 172.092V186.834C336.857 187.491 337.245 188.085 337.843 188.344C338.441 188.604 339.135 188.48 339.608 188.03L359.462 169.103C364.542 163.94 369.4 158.351 369.4 150.602C369.4 144.739 367.092 139.116 362.985 134.971C358.877 130.826 353.307 128.498 347.499 128.5ZM309.022 167.589C308.745 167.915 308.344 168.101 307.922 168.1C307.564 168.098 307.218 167.965 306.948 167.724C300.615 161.959 297.4 155.946 297.4 149.848V149.777C297.4 144.537 300.518 138.573 304.652 135.914C305.34 135.492 306.23 135.713 306.656 136.409C307.081 137.106 306.885 138.023 306.215 138.474C302.917 140.601 300.338 145.565 300.338 149.777V149.848C300.338 155.045 303.221 160.3 308.897 165.448C309.194 165.713 309.374 166.089 309.397 166.492C309.421 166.895 309.285 167.29 309.022 167.589ZM318.808 162.503C318.541 162.995 318.037 163.3 317.49 163.3C317.242 163.294 316.999 163.226 316.782 163.102C312.383 160.557 309.414 155.561 309.4 150.667V150.601C309.388 145.946 311.872 141.666 315.854 139.482C316.331 139.221 316.907 139.242 317.365 139.538C317.822 139.834 318.093 140.36 318.073 140.917C318.054 141.474 317.748 141.978 317.271 142.24C314.256 143.875 312.372 147.106 312.383 150.623C312.383 154.449 314.742 158.37 318.227 160.389C318.576 160.589 318.834 160.924 318.943 161.321C319.052 161.718 319.003 162.143 318.808 162.503ZM329.2 158.5C325.555 158.5 322.6 155.545 322.6 151.9C322.6 148.255 325.555 145.3 329.2 145.3C332.845 145.3 335.8 148.255 335.8 151.9C335.8 155.545 332.845 158.5 329.2 158.5ZM341.62 163.102C341.403 163.226 341.161 163.294 340.913 163.3C340.22 163.307 339.613 162.82 339.445 162.122C339.277 161.425 339.592 160.699 340.206 160.367C343.631 158.378 345.817 154.689 345.982 150.621C345.979 147.102 344.091 143.875 341.083 142.247C340.347 141.842 340.067 140.895 340.457 140.132C340.848 139.368 341.761 139.078 342.497 139.483C346.486 141.648 348.991 145.929 349 150.599V150.651C348.965 155.586 346.01 160.579 341.62 163.131V163.102ZM361 149.84C361 155.941 357.783 161.957 351.444 167.724C351.173 167.965 350.827 168.098 350.469 168.1C349.858 168.098 349.312 167.71 349.096 167.125C348.879 166.539 349.037 165.878 349.493 165.461C355.174 160.296 358.059 155.04 358.059 149.854V149.783C358.059 145.562 355.478 140.561 352.178 138.475C351.507 138.024 351.311 137.106 351.737 136.409C352.162 135.713 353.053 135.492 353.742 135.914C357.893 138.574 361 144.54 361 149.783V149.84Z"
        fill={theme.colors.red['600']}
      />
      <rect
        fill={theme.colors.black.primary}
        fillOpacity="0"
        height="42"
        transform="translate(251 295)"
        width="157"
      />
      <path
        d="M364 295H295C293.343 295 292 296.343 292 298V334C292 335.657 293.343 337 295 337H364C365.657 337 367 335.657 367 334V298C367 296.343 365.657 295 364 295Z"
        fill={theme.colors.gray['200']}
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <path
        d="M405 330H254C252.343 330 251 331.343 251 333V334C251 335.657 252.343 337 254 337H405C406.657 337 408 335.657 408 334V333C408 331.343 406.657 330 405 330Z"
        fill={theme.colors.gray['200']}
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <rect
        fill={theme.colors.black.primary}
        fillOpacity="0"
        height="265"
        transform="translate(448.5 72)"
        width="167"
      />
      <path
        d="M595.5 72H468.5C457.454 72 448.5 80.9543 448.5 92V317C448.5 328.046 457.454 337 468.5 337H595.5C606.546 337 615.5 328.046 615.5 317V92C615.5 80.9543 606.546 72 595.5 72Z"
        fill={theme.colors.gray['200']}
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <rect
        fill={theme.colors.black.primary}
        fillOpacity="0"
        height="117"
        transform="translate(474 202.5)"
        width="117"
      />
      <path
        d="M532.5 319.5C564.809 319.5 591 293.309 591 261C591 228.691 564.809 202.5 532.5 202.5C500.191 202.5 474 228.691 474 261C474 293.309 500.191 319.5 532.5 319.5Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <path
        d="M533 285.5C546.255 285.5 557 274.755 557 261.5C557 248.245 546.255 237.5 533 237.5C519.745 237.5 509 248.245 509 261.5C509 274.755 519.745 285.5 533 285.5Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <path
        d="M533 285.5C546.255 285.5 557 274.755 557 261.5C557 248.245 546.255 237.5 533 237.5C519.745 237.5 509 248.245 509 261.5C509 274.755 519.745 285.5 533 285.5Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <rect
        fill={theme.colors.black.primary}
        fillOpacity="0"
        height="48"
        transform="translate(509 115.5)"
        width="48"
      />
      <path
        d="M533 163.5C546.255 163.5 557 152.755 557 139.5C557 126.245 546.255 115.5 533 115.5C519.745 115.5 509 126.245 509 139.5C509 152.755 519.745 163.5 533 163.5Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <path
        d="M533 149.5C538.523 149.5 543 145.023 543 139.5C543 133.977 538.523 129.5 533 129.5C527.477 129.5 523 133.977 523 139.5C523 145.023 527.477 149.5 533 149.5Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <rect
        fill={theme.colors.black.primary}
        fillOpacity="0"
        height="266"
        transform="translate(32.5 71)"
        width="189.011"
      />
      <path
        d="M205.5 71H48.5C39.6634 71 32.5 78.1634 32.5 87V321C32.5 329.837 39.6634 337 48.5 337H205.5C214.337 337 221.5 329.837 221.5 321V87C221.5 78.1634 214.337 71 205.5 71Z"
        fill={theme.colors.gray['200']}
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <path
        d="M138.999 184.5C134.09 184.537 129.519 187.032 126.8 191.159C124.081 187.033 119.51 184.538 114.601 184.5C110.729 184.499 107.015 186.051 104.277 188.814C101.538 191.577 100 195.326 100 199.235C100 204.401 103.239 208.127 106.625 211.569L119.861 224.201C120.179 224.503 120.645 224.584 121.045 224.408C121.444 224.231 121.701 223.83 121.697 223.389V213.561C121.697 210.716 123.982 208.41 126.8 208.41C129.618 208.41 131.903 210.716 131.903 213.561V223.389C131.905 223.828 132.163 224.223 132.562 224.396C132.961 224.569 133.423 224.487 133.739 224.186L146.975 211.569C150.361 208.127 153.6 204.401 153.6 199.235C153.6 195.326 152.062 191.577 149.323 188.814C146.585 186.051 142.871 184.499 138.999 184.5ZM113.348 210.56C113.163 210.777 112.896 210.901 112.615 210.9C112.376 210.899 112.146 210.81 111.965 210.649C107.743 206.806 105.6 202.797 105.6 198.732V198.685C105.6 195.191 107.679 191.215 110.435 189.443C110.893 189.162 111.487 189.308 111.77 189.773C112.054 190.237 111.923 190.849 111.476 191.149C109.278 192.567 107.559 195.877 107.559 198.685V198.732C107.559 202.197 109.481 205.7 113.265 209.132C113.462 209.309 113.583 209.559 113.598 209.828C113.614 210.096 113.524 210.36 113.348 210.56ZM119.872 207.168C119.694 207.497 119.358 207.7 118.994 207.7C118.828 207.696 118.666 207.651 118.521 207.568C115.588 205.871 113.609 202.54 113.6 199.278V199.234C113.592 196.13 115.248 193.277 117.903 191.821C118.221 191.647 118.605 191.661 118.91 191.859C119.215 192.056 119.395 192.406 119.382 192.778C119.369 193.149 119.165 193.486 118.847 193.66C116.837 194.75 115.581 196.904 115.588 199.249C115.588 201.799 117.161 204.413 119.485 205.759C119.718 205.893 119.889 206.116 119.962 206.381C120.035 206.645 120.002 206.929 119.872 207.168ZM126.8 204.5C124.37 204.5 122.4 202.53 122.4 200.1C122.4 197.67 124.37 195.7 126.8 195.7C129.23 195.7 131.2 197.67 131.2 200.1C131.2 202.53 129.23 204.5 126.8 204.5ZM135.08 207.568C134.935 207.651 134.774 207.696 134.609 207.7C134.147 207.705 133.742 207.38 133.63 206.915C133.518 206.45 133.728 205.966 134.138 205.745C136.421 204.419 137.878 201.96 137.988 199.248C137.986 196.901 136.728 194.75 134.722 193.665C134.231 193.395 134.045 192.763 134.305 192.254C134.565 191.746 135.174 191.552 135.664 191.822C138.324 193.265 139.994 196.119 140 199.233V199.267C139.976 202.557 138.007 205.886 135.08 207.588V207.568ZM148 198.727C148 202.794 145.855 206.804 141.63 210.649C141.449 210.81 141.218 210.899 140.979 210.9C140.572 210.899 140.208 210.64 140.064 210.25C139.92 209.859 140.025 209.418 140.329 209.141C144.116 205.698 146.04 202.193 146.04 198.736V198.689C146.04 195.875 144.319 192.54 142.119 191.15C141.671 190.85 141.541 190.238 141.824 189.773C142.108 189.308 142.702 189.162 143.161 189.443C145.929 191.216 148 195.194 148 198.689V198.727Z"
        fill={theme.colors.red['600']}
      />
      <path
        d="M127 82.5C128.657 82.5 130 81.1569 130 79.5C130 77.8431 128.657 76.5 127 76.5C125.343 76.5 124 77.8431 124 79.5C124 81.1569 125.343 82.5 127 82.5Z"
        fill={ICON_STROKE_COLOR}
      />
      <path
        d="M32.5 88H221.511"
        stroke={ICON_STROKE_COLOR}
        strokeLinecap="square"
        strokeWidth="3"
      />
      <path
        d="M32.5 311H221.511"
        stroke={ICON_STROKE_COLOR}
        strokeLinecap="square"
        strokeWidth="3"
      />
      <rect
        fill={theme.colors.black.primary}
        fillOpacity="0"
        height="214"
        transform="translate(1 123.5)"
        width="112"
      />
      <path
        d="M97 123.5H17C8.16344 123.5 1 130.663 1 139.5V321.5C1 330.337 8.16344 337.5 17 337.5H97C105.837 337.5 113 330.337 113 321.5V139.5C113 130.663 105.837 123.5 97 123.5Z"
        fill={theme.colors.gray['200']}
      />
      <path
        d="M66.2493 215.5C62.5672 215.528 59.1389 217.399 57.1 220.494C55.0607 217.4 51.6327 215.528 47.9507 215.5C45.0467 215.499 42.2613 216.663 40.2076 218.736C38.1538 220.808 37 223.62 37 226.551C37 230.426 39.4291 233.22 41.9688 235.802L51.8958 245.276C52.1341 245.502 52.4835 245.563 52.7834 245.431C53.0834 245.298 53.2759 244.998 53.2726 244.667V237.296C53.2726 235.162 54.9862 233.432 57.1 233.432C59.2138 233.432 60.9274 235.162 60.9274 237.296V244.667C60.9284 244.996 61.1225 245.292 61.4215 245.422C61.7205 245.552 62.0673 245.49 62.3042 245.265L72.2312 235.802C74.7709 233.22 77.2 230.426 77.2 226.551C77.2 223.62 76.0462 220.808 73.9924 218.736C71.9387 216.663 69.1533 215.499 66.2493 215.5ZM47.0108 235.045C46.8724 235.208 46.6718 235.301 46.4612 235.3C46.2821 235.299 46.1092 235.232 45.9738 235.112C42.8074 232.23 41.2 229.223 41.2 226.174V226.138C41.2 223.518 42.759 220.537 44.8261 219.207C45.1701 218.996 45.6152 219.106 45.8278 219.455C46.0404 219.803 45.9425 220.262 45.6074 220.487C43.9585 221.551 42.6691 224.032 42.6691 226.138V226.174C42.6691 228.773 44.1106 231.4 46.9486 233.974C47.0969 234.106 47.187 234.295 47.1987 234.496C47.2104 234.697 47.1427 234.895 47.0108 235.045ZM51.9041 232.501C51.7706 232.748 51.5186 232.9 51.2452 232.9C51.1212 232.897 50.9997 232.863 50.891 232.801C48.6913 231.528 47.2071 229.03 47.2 226.583V226.55C47.1941 224.223 48.4362 222.083 50.427 220.991C50.6655 220.86 50.9535 220.871 51.1824 221.019C51.4112 221.167 51.5463 221.43 51.5366 221.708C51.5269 221.987 51.374 222.239 51.1354 222.37C49.628 223.188 48.686 224.803 48.6913 226.561C48.6913 228.474 49.8709 230.435 51.6136 231.444C51.7882 231.544 51.917 231.712 51.9715 231.911C52.026 232.109 52.0017 232.321 51.9041 232.501ZM57.1 230.5C55.2775 230.5 53.8 229.023 53.8 227.2C53.8 225.377 55.2775 223.9 57.1 223.9C58.9225 223.9 60.4 225.377 60.4 227.2C60.4 229.023 58.9225 230.5 57.1 230.5ZM63.31 232.801C63.2016 232.863 63.0804 232.897 62.9566 232.9C62.6101 232.903 62.3065 232.66 62.2224 232.311C62.1384 231.963 62.2958 231.599 62.6031 231.433C64.3155 230.439 65.4085 228.595 65.4908 226.561C65.4896 224.801 64.5457 223.187 63.0414 222.374C62.6735 222.171 62.5334 221.698 62.7286 221.316C62.9238 220.934 63.3803 220.789 63.7483 220.991C65.7432 222.074 66.9953 224.214 67 226.55V226.575C66.9823 229.043 65.5049 231.54 63.31 232.816V232.801ZM73 226.17C73 229.22 71.3913 232.228 68.2222 235.112C68.0867 235.232 67.9137 235.299 67.7344 235.3C67.4291 235.299 67.1561 235.105 67.0479 234.812C66.9397 234.52 67.0187 234.189 67.2466 233.98C70.087 231.398 71.5296 228.77 71.5296 226.177V226.142C71.5296 224.031 70.2392 221.53 68.5889 220.488C68.2536 220.262 68.1555 219.803 68.3683 219.455C68.5811 219.106 69.0266 218.996 69.3708 219.207C71.4466 220.537 73 223.52 73 226.142V226.17Z"
        fill={theme.colors.red['600']}
      />
      <path
        d="M57 329.5C61.4183 329.5 65 325.918 65 321.5C65 317.082 61.4183 313.5 57 313.5C52.5817 313.5 49 317.082 49 321.5C49 325.918 52.5817 329.5 57 329.5Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
      <path
        d="M57 137.5C58.6569 137.5 60 136.157 60 134.5C60 132.843 58.6569 131.5 57 131.5C55.3431 131.5 54 132.843 54 134.5C54 136.157 55.3431 137.5 57 137.5Z"
        fill={ICON_STROKE_COLOR}
      />
      <path
        d="M96.5 124H17.5C8.66344 124 1.5 131.163 1.5 140V321C1.5 329.837 8.66344 337 17.5 337H96.5C105.337 337 112.5 329.837 112.5 321V140C112.5 131.163 105.337 124 96.5 124Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="3"
      />
    </svg>
  );
}

export default Devices;
